import * as REGIONS from '../consts/regions';
// @ts-ignore
import getUserLocation from '../components/GeoTargetting/GeoTargetting';

export const regionsList = Object.values(REGIONS) as RegionType[];

export const DEFAULTS = {
  region: REGIONS.VIC,
};

type RegionType = {
  id: string;
  userRegionCookieValue: string;
  shortName: string;
  longName: string;
  defaultPostcode: string;
};

export const getUserPostcodeValue = (userLocationObject: any): string => {
  let newPostcode = DEFAULTS.region.defaultPostcode;
  if (userLocationObject && Array.isArray(userLocationObject.subdivisions)) {
    const matchingRegion = regionsList.find(
      (region) => region.id === userLocationObject.subdivisions[0].iso_code,
    );
    // only using the post code if the geolocation returned a valid region,
    // otherwise the post code can be some weird value depending on the country!
    if (matchingRegion && userLocationObject?.postal?.code !== '1001') {
      newPostcode = userLocationObject.postal.code || newPostcode;
    }
  }

  return newPostcode;
};

export const getPostCode = async () => {
  const location = await getUserLocation();
  return getUserPostcodeValue(location);
};
